module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic07.10a5f92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic07.png
// module id = 541
// module chunks = 1